module.exports = __webpack_public_path__ + "static/media/dinersclub.0a9d99b8.svg";